export default __webpack_public_path__ + "./images/good-4.svg";